import styled from "styled-components";

export const Button = styled.button.attrs(props => ({
  type: props.type || "button"
}))`
  display: flex;
  border: none;
  border-radius: ${props => props.theme.borderRadius};
  background: ${props => props.theme.blue};
  color: ${props => props.theme.white};
  white-space: nowrap;
  min-height: ${props => props.height || props.theme.minHeightButton};
  min-width: ${props => props.width ? (props.width + '!important') : 'auto'};
  font-weight: 600;
  font-size: ${props => props.theme.defaultFont};
  font-family: ${props => props.theme.zilla};
  text-align: center;
  cursor: pointer;
  align-items: center;
  justify-content: center;
  text-decoration: none;
  padding: ${props => props.theme.paddingBtn};

  &:hover {
    color: ${props => props.theme.white};
    background-color: ${props => props.theme.bluePressed};
  }

  &:active {
    color: ${props => props.theme.white};
    background-color: ${props => props.theme.bluePressed};
  }

  &:disabled {
    background: ${props => props.theme.disabled};
    color: ${props => props.theme.disabledText};

    &:hover {
      background-color: ${props => props.theme.disabled};
    }
  }
`;

export const SecondaryTabButton = styled.button.attrs(props => ({
  type: props.type || "button"
}))`
  display: flex;
  border: 1px solid ${props => props.theme.blue};
  border-radius: ${props => props.theme.borderRadius};
  background: ${props => props.theme.background};
  color: ${props => props.theme.blue};
  white-space: nowrap;
  min-height: ${props => props.height || props.theme.minHeightButton};
  min-width: ${props => props.width || 'auto'};
  font-weight: 600;
  font-size: ${props => props.theme.defaultFont};
  font-family: ${props => props.theme.zilla};
  text-align: center;
  cursor: pointer;
  align-items: center;
  justify-content: center;
  text-decoration: none;
  padding: ${props => props.theme.paddingBtn};

  &:hover {
    color: ${props => props.theme.white};
    background-color: ${props => props.theme.bluePressed};
  }

  &:active {
    color: ${props => props.theme.white};
    background-color: ${props => props.theme.bluePressed};
  }
`;

export const DeleteButton = styled.button.attrs(props => ({
  type: props.type || "button"
}))`
  display: flex;
  border: 1px solid ${props => props.theme.danger};
  border-radius: ${props => props.theme.borderRadius};
  background: ${props => props.theme.danger};
  color: ${props => props.theme.white};
  white-space: nowrap;
  min-height: ${props => props.theme.minHeightButtonDialog};
  min-width: ${props => props.width ? (props.width + '!important') : 'auto'};
  font-weight: 600;
  font-size: ${props => props.theme.defaultFont};
  font-family: ${props => props.theme.zilla};
  text-align: center;
  cursor: pointer;
  align-items: center;
  justify-content: center;
  text-decoration: none;
  padding: ${props => props.theme.paddingBtn};

  &:hover {
    border: 1px solid ${props => props.theme.dangerHover};
    color: ${props => props.theme.white};
    background-color: ${props => props.theme.dangerHover};
  }

  &:active {
    color: ${props => props.theme.white};
    background-color: ${props => props.theme.dangerHover};
  }
`;

export const MediumButton = styled(Button)`
  line-height: 1em;
  height: 3em;
  padding: 1em;
`;

export const LargeButton = styled(Button)`
  min-height: 24px;
  padding: 1em 2em;
  font-size: 1.5em;
`;

export const SecondaryButton = styled(Button)`
  background-color: ${props => props.theme.text3};
  color: ${props => props.theme.text};

  &:hover {
    background-color: ${props => props.theme.disabled2};
  }

  &:active {
    background-color: ${props => props.theme.disabled2};
  }

  &:disabled {
    background-color: ${props => props.theme.disabled2};
    color: ${props => props.theme.disabledText};

    &:hover {
      background-color: transparent;
    }
  }
`;

export const MenuButton = styled(Button)`
  background-color: transparent;
  color: ${props => props.theme.text2};
  padding: 1px 8px;

  &:hover {
    background-color: ${props => props.theme.hover2};
  }

  &:active {
    background-color: ${props => props.theme.hover2};
  }

  &:disabled {
    background-color: transparent;
    color: ${props => props.theme.disabledText};

    &:hover {
      background-color: transparent;
    }
  }
`;

export const PropertiesPanelButton = styled(Button)`
  align-self: center;
  justify-content: center;
  width: 200px;
`;
